import { Card, CardMedia, Divider, Grid, IconButton } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';
import theme from './theme';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF',
  },
  cover: {
    width: '100%',
    height: 180,
    [theme.breakpoints.down('sm')]: {
      height: 120,
    },
    borderRadius: (props) => (props.shareClassroom ? '0px' : '4px'),
  },
  section: {
    marginTop: '-70px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '-40px',
    },
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  item: {
    marginBottom: theme.spacing(2),
  },
  avatar: {
    borderRadius: '50%',
    width: 89,
    height: 89,
    marginBottom: 20,
  },
  iconBtn: {
    position: 'absolute',
    right: 10,
    top: 10,
    width: 30,
    height: 30,
    background: '#F3F7FF',
    border: '1px solid #C0D9FF',
  },
  btn: {
    borderRadius: 6,
    height: 36,
    width: '100%',
    marginBottom: 8,
  },
  chip: {
    borderRadius: 10,
    height: 32,
    width: 100,
    margin: 4,
  },
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
  },
  tableCell: {
    flex: 1,
    marginRight: 8,
  },
  smallBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    marginLeft: 8,
  },
}));

const DetailedSkeleton = ({ shareClassroom = false }) => {
  const classes = useStyles({ shareClassroom });

  return (
    <div className={classes.container}>
      {/* Cover image */}
      <Card elevation={0} style={{ position: 'relative', borderRadius: shareClassroom ? '0px' : '4px' }}>
        <Skeleton
          variant="rect"
          animation="wave"
          className={classes.skeletonColor}
          classes={{ root: classes.cover }}
        />
      </Card>
      {/* ProfilName */}
      <Grid container className={classes.section}>
        <Grid item xs={12} style={{ position: 'relative' }}>
          <IconButton className={classes.iconBtn} size="small">
            <Skeleton variant="circle" width={15} height={15} className={classes.skeletonColor} />
          </IconButton>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', marginLeft: 30, marginTop: '22px' }}>
            <Skeleton variant="circle" width={89} height={89} className={classes.skeletonColor + ' ' + classes.avatar} />
            <Skeleton variant="text" width={180} height={32} className={classes.skeletonColor} />
            <Skeleton variant="text" width={120} height={24} className={classes.skeletonColor} />
          </div>
        </Grid>
      </Grid>

      <Divider className={classes.divider} />
      {/* Sections */}
      <Grid container spacing={0} style={{ marginLeft: '30px' }}>
        {/* Contact */}
        <Grid item xs={12} className={classes.item}>
          <Skeleton variant="text" width={180} height={28} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={180} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            <Skeleton variant="rect" width={180} height={36} className={classes.skeletonColor + ' ' + classes.btn} />
            <Skeleton variant="rect" width={220} height={36} className={classes.skeletonColor + ' ' + classes.btn} />
          </div>
          <Divider className={classes.divider} />
        </Grid>

        <Grid item xs={12} className={classes.item}>
          <Skeleton variant="text" width={180} height={28} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={180} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <Divider className={classes.divider} />
        </Grid>

        <Grid item xs={12} className={classes.item}>
          <Skeleton variant="text" width={180} height={28} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={180} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />
          <Divider className={classes.divider} />
        </Grid>

        <Grid item xs={12} className={classes.item}>
          <Skeleton variant="text" width={180} height={28} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={170} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <Divider className={classes.divider} />
        </Grid>

        <Grid item xs={12} className={classes.item}>
          <Skeleton variant="text" width={180} height={28} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={180} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} />
          <Skeleton variant="text" width={120} height={22} className={classes.skeletonColor} style={{ marginBottom: '10px' }} />

          <Divider className={classes.divider} />
        </Grid>
      </Grid>
    </div>
  );
};

export default DetailedSkeleton; 